export enum EventRegistrationPolicyEnum {
    Unlimited,
    Limited
}
